import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import icoback from '../img/ico-back.svg';
import icobackblue from '../img/ico-backblue.svg';
import icosearch from '../img/ico-search.svg';
import icoclose from '../img/ico-close.svg';
import strings from '../strings.js'
import SongCard from '../SongCard';
import SelectingYesNoCard from '../SelectingYesNoCard';
import heart from '../img/heart.svg';
import noheart from '../img/noheart.svg';
import { SendMessage } from '../App.js';
import useSongSearch from '../useSongSearch';

const API_URL = "https://www.starboxkod.com/api";

const song1 = {
    "song_num": 110108,
    "song_name": "给我多一点",
    "singer": "SHE",
    "language": "国语",
    "server_id": "C",
    "rel_path": "05\\110108"
}



export function Hot({cookieFavs, setCookieFavs, stateVer, lang, selectingYesNo, tableNo, setSelectedSinger}) {

    const [searchTerm, setSearchTerm] = useState(JSON.parse(localStorage.getItem("top")).all);
    const [pageNumber, setPageNumber] = useState(0);
    const [searchLang, setSearchLang] = useState("language")

    const [pleaseWait, setPleaseWait] = useState(true);

    const {
        loading,
        error,
        songs,
        hasMore
    } = useSongSearch(searchTerm, pageNumber)

    const lookup = Object.fromEntries(songs.map(o => [o.song_num, o]));

    useEffect(()=> {
        setPleaseWait(false)
    }, [lookup])
   
    useEffect(() => {
        setPageNumber(0)
        document.getElementById("song-container").scrollTop =0;
      }, [searchTerm])


    const langOptions = [
  { id: "language", labelKey: "songall", topKey: "all", blockCode: null },
  { id: "国语", labelKey: "国语", topKey: "chi", blockCode: 2 },
  { id: "粤语", labelKey: "粤语", topKey: "can", blockCode: 7 },
  { id: "台语", labelKey: "台语", topKey: "hok", blockCode: 5 },
  { id: "潮语", labelKey: "潮语", topKey: "teo", blockCode: 15 },
  { id: "英语", labelKey: "英语", topKey: "eng", blockCode: 6 },
  { id: "马来", labelKey: "马来", topKey: "mal", blockCode: 9 },
  { id: "日语", labelKey: "日语", topKey: "jap", blockCode: 4 },
  { id: "韩语", labelKey: "韩语", topKey: "kor", blockCode: 3 },
  { id: "泰语", labelKey: "泰语", topKey: "tha", blockCode: 10 },
  { id: "印度语", labelKey: "印度语", topKey: "ind", blockCode: 13 },
  { id: "越南语", labelKey: "越南语", topKey: "vie", blockCode: 12 },
  { id: "菲律宾语", labelKey: "菲律宾语", topKey: "phi", blockCode: 14 },
];

    const [blockedLangs, setBlockedLangs] = useState(() => {
        const item = localStorage.getItem("black");
        if (!item) return []; // Fallback if key doesn't exist
        
        const parsed = JSON.parse(item);
        return parsed?.language ?? [];
    });

      
    const [selectingYesNoSong, setSelectingYesNoSong] = useState({});
    
    const navigate = useNavigate()

    return (<>
    <div className="purpleHeader26" style={{marginTop: '0'}}>
    <div className="heatder" style={{backgroundImage:'none'}}>
        <a onClick={(e) => {e.preventDefault(); navigate(-1)}}>
        <img
            src={icoback}
            alt="back"
        />
        </a>
        <div className = "headerReplaceText">{lang ? strings.cn.hot : strings.en.hot}</div>
        <div className = "headerEndText">{/* {songs.length} */}</div>



    </div>
                    <div className="language-bar-container" style={{marginTop: '62px', paddingTop: 'calc(-62px + 4.5rem)'}}>
                        <div className="language-bar">
                            {langOptions.map((option) => {
                            // Skip rendering if language code is blocked
                            if (option.blockCode !== null && blockedLangs.includes(option.blockCode)) {
                            return null;
                            }

                            return (
                            <div
                                key={option.id}
                                className={`pill-btn ${searchLang === option.id ? "selected" : ""}`}
                                onClick={(e) => {
                                e.preventDefault();
                                setPleaseWait(true);
                                setSearchLang(option.id);
                                const topData = JSON.parse(localStorage.getItem("top")) || {};
                                setSearchTerm(topData[option.topKey]);
                                }}
                            >
                                {lang ? strings.cn[option.labelKey] : strings.en[option.labelKey]}
                            </div>
                            );
                        })}
                        </div>
        </div>
    </div>

    <div className="song-container" id="song-container">
    {songs?.length > 0 && !pleaseWait
        ? (
            <>
                {searchTerm.map((song_num, index) => {
                    return <SongCard setSelectedSinger={setSelectedSinger} song={lookup[song_num]} key={index} stateVer={stateVer} lang={lang} onClick={() => { setSelectingYesNoSong(lookup[song_num]);         navigate("/home/hot/select")}}/>                  
                })}     
            </>
        ) :
        (
            <div className="empty">
                <h2>No songs found</h2>
            </div>
        )}
    </div>

    {loading && 'Loading...'}
    {error && 'Error...'}

    { selectingYesNo && (
        <>
        <SelectingYesNoCard cookieFavs={cookieFavs} setCookieFavs={setCookieFavs} song={selectingYesNoSong} onClick={() => { navigate(-1);}} stateVer={stateVer} lang={lang} tableNo={tableNo}/>
        </>
    )}
    
</>)}
